import React, { Dispatch, SetStateAction } from 'react';
import styles from '../activityAssociations.module.scss';
import { getAssociationLength } from 'v2/utils/activityUtils';
import classnames from 'classnames';
import {
  ActivityAssociation,
  GroupEntityLabelKey,
  useGroupEntityLabel,
} from 'v2/models';

export interface ActivityAssociationsTypeProps {
  currentAssociationType: GroupEntityLabelKey;
  setCurrentAssociationType: Dispatch<SetStateAction<GroupEntityLabelKey>>;
  checkedAssociations: Array<ActivityAssociation>;
}

const ActivityAssociationsType = ({
  currentAssociationType,
  setCurrentAssociationType,
  checkedAssociations,
}: ActivityAssociationsTypeProps) => {
  const groupEntityLabel = useGroupEntityLabel();

  return (
    <div className={styles.associationTypes}>
      <nav
        aria-label="associationTypeList"
        role="tablist"
        className={styles.nav}
      >
        <ul className={styles.ul}>
          {Object.entries(groupEntityLabel).map(([type, label], index) => (
            <li
              key={type}
              onClick={() =>
                setCurrentAssociationType(type as GroupEntityLabelKey)
              }
            >
              <div
                className={classnames(
                  {
                    [styles.associationTypeSelected]:
                      type === currentAssociationType,
                  },
                  {
                    [styles.associations]: type === 'ALL',
                  },
                  styles.associationType
                )}
              >
                <div className={classnames(styles.inner)}>
                  <div
                    className={styles.inbox_box}
                    data-testid={`association_${index}`}
                  >
                    <div className={classnames(styles.wrapText)}>
                      <span>{label}</span>
                    </div>
                    <span>
                      {getAssociationLength(
                        checkedAssociations,
                        type === 'ALL' ? undefined : type
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default ActivityAssociationsType;
